import React from "react";
import {FieldValues, useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";

import "./CreateUser.css";
import {useNavigate} from "react-router-dom";
import {authService, Header, useAppSelector, UserRole} from "@shared/ui";

const CreateUser: React.FC = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      login: "",
      displayName: "",
      role: "",
      password: "",
      passwordAgain: "",
    },
  });
  const { t } = useTranslation();
  const customer = useAppSelector((store) => store.customer.value);
  const currUser = useAppSelector((store) => store.user.value);
  const navigate = useNavigate();

  const createUser = (data: FieldValues) => {
    if (customer) {
      authService
        .createUser(
          customer.id,
          data.displayName.trim(),
          data.login,
          data.password.trim(),
          data.passwordAgain.trim(),
          data.role,
        )
        .then((data) => {
          navigate("/dashboard?tab=1");
        })
        .catch();
    }
  };
  return (
    <div className="form-page">
      <div className="container">
        <Header />

        <div className="form-wrapper">
          <h1 className="text-center">{t("createUser.title")}</h1>

          <form
            onSubmit={handleSubmit((data) => {
              createUser(data);
            })}
          >
            <label>{t("createUser.labels.login")}</label>
            <input {...register("login", { required: true, minLength: 2 })} />
            {errors.login && (
              <span className="error">{t("createUser.errors.required")}</span>
            )}

            <label>{t("createUser.labels.name")}</label>
            <input
              {...register("displayName", { required: true, minLength: 1 })}
            />
            {errors.displayName && (
              <span className="error">{t("createUser.errors.required")}</span>
            )}

            <label>{t("createUser.labels.role")}</label>
            <select {...register("role", { required: true })}>
              {currUser?.role === UserRole.SuperAdmin ||
                  currUser?.role == UserRole.ServiceAdmin ? (
                <option key={1} value={UserRole.CustomerSuperAdmin}>
                  {t("createUser.roles.superAdmin")}
                </option>
              ) : null}
              {currUser?.role === UserRole.SuperAdmin ||
              currUser?.role == UserRole.CustomerSuperAdmin ? (
                <option key={2} value={UserRole.CustomerAdmin}>
                  {t("createUser.roles.admin")}
                </option>
              ) : null}
              {currUser?.role === UserRole.SuperAdmin ? (
                  <option key={2} value={UserRole.ServiceAdmin}>
                    {t("createUser.roles.serviceAdmin")}
                  </option>
              ) : null}
              <option key={3} value={UserRole.Operator}>
                {t("createUser.roles.operator")}
              </option>
            </select>
            {errors.role && (
              <span className="error">{t("createUser.errors.required")}</span>
            )}

            <label htmlFor="password">{t("createUser.labels.password")}</label>
            <input
              id="password"
              {...register("password", {
                required: t("createUser.errors.required"),
                minLength: {
                  value: 5,
                  message: "min length is 5",
                },
              })}
              type="password"
            />
            {errors.password && (
              <span className="error">{errors.password.message}</span>
            )}

            <label htmlFor="password">{t("createUser.labels.repeatPassword")}</label>
            <input
              id="passwordAgain"
              {...register("passwordAgain", {
                required: t("createUser.errors.required"),
                minLength: {
                  value: 5,
                  message: "min length is 5",
                },
              })}
              type="password"
            />
            {errors.passwordAgain && (
              <span className="error">{errors.passwordAgain.message}</span>
            )}
            <input type="submit" value={t("createUser.submit")} />
          </form>
        </div>
      </div>
    </div>
  );
};
export default CreateUser;
